<template lang="pug" src="./ref-register.pug"> </template>
<style lang="scss" scoped src="./ref-register.scss"> </style>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import validate from '@/mixins/validate'

import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import api from '@/utils/api'

export default {
    components: {
        'phone-number': () => import('vue-phone-number-input'),
        'code-input': () => import('@/components/CodeInput')
    },
    mixins: [validationMixin, validate],
    data: () => ({
        phone: '',
        isValid: false,
        confirmation: '',
        isButtonsEnabled: false,
        googlePlayUrl: process.env.VUE_APP_GOOGLE_PLAY,
        appStoreUrl: process.env.VUE_APP_APPSTORE
    }),
    validations: {
        confirmation: {
            valid: function() {
                return this.confirmation.length === this.confirmedCodeLength
            }
        }
    },
    computed: {
        ...mapState({
            refStatus: state => state.refRegister.refStatus,
            formattedPhone: state => state.refRegister.formattedPhone,
            sessionToken: state => state.refRegister.sessionToken,
            referralCode: state => state.refRegister.referralCode,
            confirmedCodeLength: state => state.refRegister.confirmedLength
        }),
        phoneLocale: function() {
            const params = ['countrySelectorLabel', 'phoneNumberLabel', 'example']
            return Object.assign(...params.map(key => ({
                [key]: this.$vuetify.t(`$vuetify.phone.${key}`)
            })))
        },
        canShowConfirmation() {
            return ['confirmation', 'registered'].includes(this.refStatus)
        },
        links() {
            const { current: currentLang } = this.$vuetify.lang

            return [{
                title: 'appStore',
                href: `${this.appStoreUrl}?l=${currentLang}`,
                icon: this.isButtonsEnabled ? 'app-store-light' : 'app-store'
            }, {
                title: 'googlePlay',
                href: `${this.googlePlayUrl}&hl=ru`,
                icon: this.isButtonsEnabled ? 'google-play-light' : 'google-play'
            }]
        }
    },
    created: function() {
        window.addEventListener('keyup', this.confirmationKeyup)
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.confirmationKeyup)
    },
    methods: {
        onChange(phone) {
            this.isValid = !!phone.isValid
            this.$store.commit('refRegister/SET_FORMATTED_PHONE', phone.formatInternational)
        },
        async createSession() {
            const phone = this.formatPhone(this.formattedPhone)

            await api({
                method: 'get',
                url: '/profile/check-phone',
                params: { phone }
            }).then(res => {
                if (!res.data.phoneExist) {
                    this.$store.commit('refRegister/SET_REF_STATUS', 'confirmation')
                    this.$store.dispatch('refRegister/createSession', phone)

                    this.isButtonsEnabled = false
                } else {
                    this.isButtonsEnabled = true

                    this.$store.dispatch('addMessage', {
                        status: 'error',
                        message: 'isPhoneExist'
                    }, { root: true })
                }
            }).finally(() => {
                this.phone = ''
            })
        },
        confirmSession() {
            const data = {
                sessionToken: this.sessionToken,
                confirmation: this.confirmation,
                referralCode: this.referralCode
            }

            this.$store.dispatch('refRegister/confirmSession', data).then(status => {
                const validStatuses = [201, 205]

                if (status && validStatuses.includes(status)) {
                    this.isButtonsEnabled = true
                }
            })

            this.$refs.codeInput.inputValues = []
            this.confirmation = ''
        },
        changePhoneNumber() {
            this.$store.commit('refRegister/SET_REF_STATUS', 'validCode')
        },
        resend() {
            this.$store.dispatch('refRegister/createSession', this.formatPhone(this.formattedPhone))
            this.$store.dispatch('addMessage', {
                type: 'success',
                message: 'resend'
            })
        },
        onClose() {
            this.confirmation = ''
        },
        formatPhone(phone) {
            return phone.split(' ').join('').substring(1)
        },
        confirmationKeyup(event) {
            if (event.keyCode === 13 && !this.$v.confirmation.$invalid) {
                this.confirmSession()
            }
        }
    }
}
</script>
